import React, { useEffect, useState } from 'react';
import {
    Card, CardContent, Typography, Button, Grid, TextField, Dialog, DialogTitle,
    DialogContent, DialogContentText, DialogActions
} from '@material-ui/core';
import axios from 'axios';
import { useGetIdentity } from 'react-admin';

const RequestHolidayForm = () => {
    const { identity, isLoading } = useGetIdentity();
    const [selectedDate, setSelectedDate] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogError, setDialogError] = useState(false);

    const handleRequest = async () => {
        if (!selectedDate) {
            showDialog("Please select a date", true);
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/holidays`, {
                employeeId: identity?.id,
                holidayDate: new Date(selectedDate)
            });
            showDialog("Holiday request submitted successfully.", false);
        } catch (err) {
            const message = err?.response?.data?.message || 'Unexpected error when requesting holiday';
            showDialog(message, true);
        }
    };

    const showDialog = (message, isError) => {
        setDialogMessage(message);
        setDialogError(isError);
        setDialogOpen(true);
    };

    if (isLoading) return <p>Loading...</p>;

    return (
        <>
            <Card style={{ maxWidth: 500, margin: '2rem auto' }}>
                <CardContent>
                    <Typography variant="h5">Request Holiday</Typography>
                    <Grid container spacing={2} style={{ marginTop: '1rem' }}>
                        <Grid item xs={12}>
                            <TextField
                                label="Date"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={handleRequest}>
                                Submit Request
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>{dialogError ? 'Error' : 'Success'}</DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ color: dialogError ? 'red' : 'green' }}>
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RequestHolidayForm;
